import React from "react";

import { IS_BROWSER } from "@config/consts";

import { AVAILABLE_LANGS } from "@typings/globals";

import { Text } from "@ui/Atoms/Text";

import { ServiceSelector } from "@features/ServiceSelector";

import { Markdown } from "@containers/Markdown";

import { useTranslate } from "@hooks/useTranslate";
import { useConfig } from "@hooks/useConfig";

import * as Styled from "./Selector.styled";

interface Props {
  className?: string;
  language: AVAILABLE_LANGS;
}

export const Selector: React.FC<Props> = props => {
  const translate = useTranslate("batmaid_pwa_static_homepage");
  const ratingScore = useConfig<number>(["globalRatingScore"]);
  const areLegaLinksVisible = useConfig<boolean>(["legalLinksOnHomePage"]);

  const roundScore = Math.round(ratingScore);

  const submitHandler = (url: string): void => {
    if (!IS_BROWSER) return;

    window.location.href = url;
  };

  return (
    <Styled.Root className={props.className}>
      <ServiceSelector
        language={props.language}
        onSuccess={submitHandler}
        isSSG
      />

      <Styled.Wrapper>
        {areLegaLinksVisible && (
          <Styled.LinksGroup>
            <Markdown
              components={{
                a: props => (
                  <Styled.Link to={props.href || ""}>
                    {props.children}
                  </Styled.Link>
                ),
              }}
            >
              {translate("terms_of_use_link")}
            </Markdown>

            <Styled.Separator />

            <Markdown
              components={{
                a: props => (
                  <Styled.Link to={props.href || ""}>
                    {props.children}
                  </Styled.Link>
                ),
              }}
            >
              {translate("privacy_policy_link")}
            </Markdown>
          </Styled.LinksGroup>
        )}

        <Styled.ScoreBody>
          <Styled.ScoreHeader>
            <Styled.StarsWrapper>
              {Array.from({ length: 5 }).map((_, index) => (
                <Styled.StarIcon
                  $isFilled={roundScore - 1 >= index}
                  key={index}
                />
              ))}
            </Styled.StarsWrapper>

            <Text $style="bold_16">{ratingScore}/5</Text>
          </Styled.ScoreHeader>

          <Styled.Content>{translate("rating_description")}</Styled.Content>
        </Styled.ScoreBody>
      </Styled.Wrapper>
    </Styled.Root>
  );
};
